import { FC } from 'react';
import { useRouteMatch, Route, Switch } from 'react-router-dom';
import DynamicPages from './pages';

const DynamicPage: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`} component={DynamicPages} />
    </Switch>
  );
};

export default DynamicPage;
